import { Button } from 'foundations-components/transitional/components/Button';
import { H7 } from 'foundations-components/transitional/components/H7';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../../utils/usageTracker';
import ACInlineContentCard from 'academy-common-lib/components/card/ACInlineContentCard';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { useState } from 'react';
// @ts-expect-error Could not find a declaration file for module
import FormattedDuration from 'I18n/components/FormattedDuration';
import { List } from 'foundations-components/transitional/components/List';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { isPrerenderAgent } from '../../../utils/prerender';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import I18n from 'I18n';
import { resize } from 'FileManagerCore/utils/resize';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Text } from 'foundations-components/components/Text';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { UpIcon } from 'foundations-assets/icons/components/UpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicCurriculumCard = ({
  title,
  href,
  landingPagePath,
  duration,
  description,
  instructorName,
  contentTypeName,
  id,
  thumbnailUrl
}) => {
  const isMarketingThemeEnabled = getMarketingThemePreference();
  const [expanded, setExpanded] = useState(false);
  const {
    isMobile
  } = useMediaQuery();
  const resizedThumbnailUrl = thumbnailUrl ? resize(thumbnailUrl, {
    length: 100
  }) : undefined;
  const toggleExpanded = () => setExpanded(!expanded);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(ACInlineContentCard, {
      endSlot: /*#__PURE__*/_jsxs(View, {
        cursor: "pointer",
        onClick: toggleExpanded,
        children: [/*#__PURE__*/_jsx(IconHolder, {
          icon: expanded ? UpIcon : DownIcon
        }), /*#__PURE__*/_jsx(H7, {
          display: "inline",
          marginBlockEnd: "0",
          marginInlineStart: "400",
          children: expanded ? I18n.text('academyPublic.curriculum.readLess') : I18n.text('academyPublic.curriculum.readMore')
        })]
      }),
      footer: /*#__PURE__*/_jsx(View, {
        insetBlockEnd: "-3px",
        position: "relative",
        children: /*#__PURE__*/_jsxs(List, {
          inline: true,
          wrapChildren: true,
          children: [contentTypeName, duration && /*#__PURE__*/_jsx(FormattedDuration, {
            format: "medium",
            from: +new Date() - duration * 1000
          })]
        })
      }),
      id: id,
      name: title,
      onClick: toggleExpanded,
      thumbnailSrc: resizedThumbnailUrl,
      use: "on-dark"
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: expanded || isPrerenderAgent(),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: isMobile ? 'column' : 'row',
        gap: "300",
        paddingBlockStart: "600",
        children: [/*#__PURE__*/_jsxs(View, {
          flex: "1",
          children: [instructorName && /*#__PURE__*/_jsx(H7, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.curriculum.lessonInstructor",
              options: {
                instructorName
              }
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            marginBlockEnd: "200",
            marginInlineEnd: "600",
            children: description
          }), landingPagePath && /*#__PURE__*/_jsx(RouterLink, {
            to: `/lessons/${landingPagePath}`,
            use: "on-dark",
            children: /*#__PURE__*/_jsx(Text, {
              color: isMarketingThemeEnabled ? 'text-core-on-fill-default' : 'text-inverse-default',
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.curriculum.seeFullDetails"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Button, {
          href: href,
          onClick: () => {
            usageTracker.track('interaction', {
              action: 'start-lesson-click',
              href
            });
          },
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.curriculum.startCourse"
          })
        })]
      })
    })]
  });
};
export default PublicCurriculumCard;